/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import * as Topological from 'fierry/util/topological';


export default class
{
  constructor (planet)
  {
    this.planet = planet;

    this.collection = [];

    this.firstRun = true;
  }


  push (zone)
  {
    this.collection.push(zone);
  }


  execute ()
  {
    while (this.firstRun || this.planet.getAttributes().hasZoneWinnerChanged())
    {
      this.firstRun = false;

      this.planet.getAttributes().setZoneWinnerChanged(false);

      this.collection = Topological.sort(this.collection, (zone) =>
      {
        return zone.getDirections().getOutgoingZones();
      });

      for (const zone of this.collection)
      {
        zone.getInfluences().install();
      }
    }
  }


};
